import { render } from "./Campanha.vue?vue&type=template&id=b303eea6&ts=true"
import script from "./Campanha.vue?vue&type=script&lang=ts"
export * from "./Campanha.vue?vue&type=script&lang=ts"

import "./Campanha.vue?vue&type=style&index=0&id=b303eea6&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__